var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'dayplan-preview': true,
  'is-selectable': !_vm.showTime,
  'is-invalid': _vm.checkValidity
}},[_c('h3',[_vm._v("Plan "+_vm._s(_vm.planId))]),_vm._l((_vm.plan),function(item,idx){return _c('div',{key:item.label,class:{
      'dayplan-preview__item': true,
      'dayplan-preview--selected': _vm.selected
    },style:({
      minHeight:  '23px',
      height:     _vm.calcItemHeight(item) + 'px',
      lineHeight: _vm.calcItemHeight(item) + 'px'
    }),on:{"click":_vm.onClick}},[_vm._v("\n    "+_vm._s(item.label)+"\n    "),(_vm.showTime)?_c('span',{staticClass:"dayplan-preview__time"},[_c('time-selector-inline',{attrs:{"value":_vm.numToTime(item.from)},on:{"save":function($event){return _vm.onUpdate( idx, $event )}}})],1):_vm._e()])}),(_vm.checkValidity)?_c('div',{staticClass:"text-center"},[_vm._v("Invalid input")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }